import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";

import { TextField, Button, FormHelperText } from "@material-ui/core";
import Select from "react-select";

export const BankingInfoComponent = ({
  permissions,
  is_super_admin,
  optionsRecord,
  submitRecord,
  errorObj,
  lang,
  showPasswordsManager,
  isUpdate = false,
  showMessage,
  handleAppError,
  setLoading,
  billingProfiles,
}) => {
  console.log({ optionsRecord, billingProfiles });
  const {
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      bankaccountname: optionsRecord.bankaccountname,
      iban: optionsRecord.iban,
      bankname: optionsRecord.bankname,
      activesystemcreditcardid:
        Number(optionsRecord.activesystemcreditcardid) || "",
    },
  });
  console.log({ watch: watch() });
  useEffect(() => {
    if (errorObj) {
      console.log("setting errors ...");
      Object.keys(errorObj).forEach((key) => {
        setError(key, { type: "custom", message: errorObj[key][0] });
      });
    }
  }, [errorObj, setError]);
  const validationMessages = (error, fieldName = "This field") => {
    if (error.type === "required") {
      return (
        window.sys_app_translate(fieldName, lang) +
        " " +
        window.sys_app_translate("is required", lang)
      );
    }
    if (error.type === "pattern") {
      switch (fieldName) {
        default:
          return (
            window.sys_app_translate(fieldName, lang) +
            " " +
            window.sys_app_translate("is not correct", lang)
          );
      }
    }
    if (error.type === "custom") {
      return error.message;
    }
  };
  const creditCardOptions = (billingProfiles || []).map((profile) => ({
    value: profile.id,
    label: `${profile.agencyname} - ${profile.carrinitials} (****${profile.lastfourdigits})`,
  }));

  const onSubmit = (values) => {
    console.log("submitting options ...");
    optionsRecord.bankaccountname = values.bankaccountname;
    optionsRecord.iban = values.iban;
    optionsRecord.bankname = values.bankname;
    optionsRecord.activesystemcreditcardid = values.activesystemcreditcardid;

    submitRecord(optionsRecord);
    return;
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row" style={{ marginTop: "1.5rem" }}>
          <div className="col-12 my-2 offset-1 offset-sm-0">
            <span style={{ fontWeight: "bold" }}>
              {window.sys_app_translate("System Credit Card Info", lang)}
            </span>
          </div>
        </div>
        {/*activesystemcreditcardid*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="activesystemcreditcardid"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <React.Fragment>
                  <Select
                    className="itqan-react-select-field"
                    options={creditCardOptions}
                    placeholder={window.sys_app_translate(
                      "Active System Credit Card",
                      lang,
                    )}
                    value={
                      creditCardOptions.find(
                        (option) => option.value === field.value,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      field.onChange(selectedOption ? selectedOption.value : "")
                    }
                    onBlur={field.onBlur}
                    isClearable
                  />
                  {errors.activesystemcreditcardid && (
                    <FormHelperText error>
                      {validationMessages(
                        errors.activesystemcreditcardid,
                        "Note",
                      )}
                    </FormHelperText>
                  )}
                </React.Fragment>
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <hr style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }} />
          </div>
        </div>

        {/*bankaccountname*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankaccountname"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="BankAccountName"
                  className="itqan-text-field"
                  label={window.sys_app_translate("Bank Account Name", lang)}
                  variant="outlined"
                  error={errors.bankaccountname ? true : false}
                  helperText={
                    errors.bankaccountname &&
                    validationMessages(errors.bankaccountname, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>
        {/*iban*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="iban"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="IBAN"
                  className="itqan-text-field"
                  label={window.sys_app_translate("IBAN", lang)}
                  variant="outlined"
                  error={errors.iban ? true : false}
                  helperText={
                    errors.iban && validationMessages(errors.iban, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>
        {/*bankname*/}
        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="col-10 offset-1 col-sm-4 offset-sm-0">
            <Controller
              name="bankname"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <TextField
                  id="BankName"
                  className="itqan-text-field"
                  label={window.sys_app_translate("Bank Name", lang)}
                  variant="outlined"
                  error={errors.bankname ? true : false}
                  helperText={
                    errors.bankname &&
                    validationMessages(errors.bankname, "Note")
                  }
                  {...field}
                />
              )}
            />
          </div>
        </div>

        {/*Submit button*/}
        <div
          className="row d-flex justify-content-start form-row"
          style={{ marginTop: "1rem" }}
        >
          <div className="col-10 offset-1 col-sm-6 offset-sm-0 d-flex justify-content-start">
            <Button
              variant="contained"
              style={{ display: "inline" }}
              type="submit"
              className="itqan-form-button"
              onClick={() => {}}
            >
              {window.sys_app_translate("Update", lang)}
            </Button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};
